<template>
  <div class="match-draw">
    <div class="draw-list">
      <div
        class="draw-item"
        v-for="(item, index) in iconList"
        :key="index"
        :style="{ marginRight: index % 3 != 2 ? '30px' : '' }"
      >
        <img class="img" :src="item.icon" alt="" />
        <div class="down">
          <div class="title">{{ item.title }}</div>
          <div class="des">{{ item.des }}</div>
        </div>
      </div>
    </div>
    <a-divider />
    <div class="info">本部分费用，根据项目和赛制不同价格不同，详询赛事专员</div>
  </div>
</template>

<script>
export default {
  name: 'MatchCenterDraw',
  props: {},
  data() {
    return {
      iconList: [
        {
          title: '智能匹配对手',
          des: '根据比赛人数，系统灵活智能匹配对手，达到公平公正',
          icon: 'https://static.daoba.com/pc/matchcenter/draw1.png',
        },
        {
          title: '灵活分配比赛场地',
          des: '达到每个场地场次均衡，大大缩短比赛时长',
          icon: 'https://static.daoba.com/pc/matchcenter/draw2.png',
        },
        {
          title: '科学排列出场顺序',
          des: '科学排列各年龄阶段出场顺序，缩短等待护具穿戴时长',
          icon: 'https://static.daoba.com/pc/matchcenter/draw3.png',
        },
        {
          title: '一键生成对战',
          des: '对战实时同步官网、小程序，实时查看赛程、对战列表',
          icon: 'https://static.daoba.com/pc/matchcenter/draw4.png',
        },
        {
          title: '对战数据实时下载',
          des: '实时下载对战数据列表',
          icon: 'https://static.daoba.com/pc/matchcenter/draw5.png',
        },
        {
          title: '晋级展示',
          des: '实时显示比赛结果，晋级关系一目了然',
          icon: 'https://static.daoba.com/pc/matchcenter/draw6.png',
        },
      ],
    }
  },
  created() {},
  methods: {},
}
</script>

<style scoped lang="scss">
.match-draw {
  width: 1200px;
  margin: 0 auto;

  .draw-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;
    padding-top: 110px;
    .draw-item {
      width: 380px;
      height: 350px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      color: #333;
      margin-bottom: 30px;
      box-sizing: border-box;
      .img {
        width: 380px;
        height: 250px;
      }
      .down {
        height: 100px;
        width: 100%;
        background-color: #e9e9e9;
        padding: 20px;
        box-sizing: border-box;
        .title {
          font-size: 20px;
          margin-bottom: 10px;
          font-weight: bold;
        }
        .des {
          font-size: 14px;
        }
      }
    }
  }
  .info {
    margin-top: 20px;
    margin-bottom: 30px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/matchcenter/components/MatchCenterDraw.vue